<template lang="pug">
div
  header
    h1 New API Key
  Form
</template>

<script>
  import { mapStores } from 'pinia'
  import { useApiClientStore } from '@/stores/api_client'

  import Form from '../shared/form.vue'

  export default {
    components: {
      Form
    },

    computed: {
      ...mapStores(useApiClientStore)
    },

    mounted() {
      this.apiClientStore.$reset()
    }
  }
</script>
